import "./HelpCenterSidebar.scss"

import Field from "@/shared/components/intrinsic/Field/Field"
import { inputValue } from "@/utils/common"

import { HelpCenterSidebarProps } from "../../types"
import HelpCenterNavTree from "../HelpCenterNavTree/HelpCenterNavTree"

function HelpCenterSidebar(props: HelpCenterSidebarProps) {
  return (
    <div className="help-center-sidebar">
      <div className="help-center-sidebar__search">
        <Field
          iconLeft="loupe"
          placeholder="Search"
          value={props.searchValue}
          onChange={inputValue(props.onSearchChange)}
          theme="light"
        />
      </div>
      <nav className="help-center-sidebar__nav">
        <HelpCenterNavTree
          items={props.navItems}
          activeSectionId={props.activeSectionId}
          onNavigate={props.onNavigate}
          searchQuery={props.searchValue}
          currentPath={props.currentPath}
        />
      </nav>
    </div>
  )
}

export default HelpCenterSidebar
